import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a27f8a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["data-index"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.digits, (digit, index) => {
      return (_openBlock(), _createElementBlock("input", {
        class: "pin-input col-2 border-radius-8 q-py-xs bg-tes-grey-light",
        key: digit,
        type: "text",
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.movement && _ctx.movement(...args))),
        onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveBack && _ctx.moveBack(...args))),
        maxlength: "1",
        ref: _ctx.setInputRef,
        "data-index": index
      }, null, 40, _hoisted_2))
    }), 128))
  ]))
}